import { Box, Stack, useMediaQuery } from '@mui/material'
import gaiaTheme from '../../../root-components/theme'
import { ReductionForm } from '../../presentation-components/reduction-components/reduction-form'
import React, { useEffect, useState } from 'react'
import { IReductionTargetPageState } from '../../../shared/services/target-setting/target-setting.model'
import TargetSettingService from '../../../shared/services/target-setting/target-setting.service'
import { ReductionVisualDisplay } from '../../presentation-components/reduction-components/reduction-visual-display'
import { PageHeading } from '../../presentation-components/display-elements-components/page-heading'
import { LoadingPage } from '../loading-page'
import { InformationBox } from '../../presentation-components/miscellaneous-components/information-box'
import { IconName } from '../../../shared/interfaces/icon-picker.model'

export const ReductionTargetPage = () => {
  const targetSettingService = new TargetSettingService()
  const [pageState, setPageState] = useState<IReductionTargetPageState | null>(null)
  const [isLoading, setIsLoading] = useState(true)
  const isMobileModeSm = useMediaQuery(gaiaTheme.breakpoints.down('sm'))

  const getPageState = () => {
    targetSettingService
      .getReductionTargetPageState()
      .then((state) => setPageState(state))
      .catch((err) => {
        console.log(err)
        setPageState({ exists: false, canCreate: false, reason: 'There has been an error loading this page, please try again' })
      })
      .finally(() => setIsLoading(false))
  }

  useEffect(() => {
    getPageState()
  }, [])

  return (
    <Box sx={{ pb: isMobileModeSm ? 3 : 6, pl: isMobileModeSm ? 3 : 6, pr: isMobileModeSm ? 3 : 6, pt: isMobileModeSm ? 3 : 5, mt: isMobileModeSm ? 5 : 0 }}>
      <PageHeading title="Reduction Targets" hasTabs={false} />
      <LoadingPage pageReady={!isLoading && pageState != null}>
        {pageState?.exists && <ReductionVisualDisplay onPlanReset={getPageState} />}
        {pageState && !pageState.exists && pageState.canCreate && pageState.baseYear && (
          <ReductionForm baseYear={pageState.baseYear} onPlanCreated={getPageState} />
        )}
        {pageState && !pageState.exists && pageState.canCreate === false && pageState.reason && (
          <Stack sx={{ mb: 2 }}>
            <InformationBox icon={IconName.ErrorOutline} text={pageState.reason} />
          </Stack>
        )}
      </LoadingPage>
    </Box>
  )
}
